import { render, staticRenderFns } from "./SectionSponsors.vue?vue&type=template&id=49be9a98&"
import script from "./SectionSponsors.vue?vue&type=script&lang=js&"
export * from "./SectionSponsors.vue?vue&type=script&lang=js&"
import style0 from "./SectionSponsors.vue?vue&type=style&index=0&id=49be9a98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports